import React, { useState } from 'react';
import { Grid, InputAdornment } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input'
import { EmailRounded } from '@material-ui/icons';
import { validateEmail } from 'utils/utils'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiInput-root': {
      width: '25ch',
    }
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  },
  chip: {
    width: '80% !important'
  }
}));

function DealEmail(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const states = useSelector(state => {
      return state.globalStates
    })

    const emails = states ? states.person_emails ? [...states.person_emails] : [] : [];

    const handleAddEmail = (email) => {
      const isEmailValid = validateEmail(email);
      if(!isEmailValid) {
        alert(`${ email } is not a valid email address.`);
      } else {
        dispatch({
          type: ACTIONS.UPDATE_PERSON_EMAILS,
          payload: [...emails, email]
        })
      }
    }
    const handleDeleteEmail = (email, index) => {
      dispatch({
        type: ACTIONS.UPDATE_PERSON_EMAILS,
        payload: emails.filter(emailItem => emailItem !== email)
      })
    }
    
    return(
        <Grid item xs={6}>
          <Grid container spacing={1} alignItems="flex-end">
            <Grid item>
              <EmailRounded />
            </Grid>
            <Grid item className={ classes.chip }>
              <ChipInput
                fullWidth
                className={ classes.root }
                blurBehavior={ `add` }
                id={ `deal-email` }
                name={ `deal_email` }
                value={emails}
                onAdd={(email) => handleAddEmail(email)}
                onDelete={(email, index) => handleDeleteEmail(email, index)}
              />
            </Grid>
          </Grid>
        </Grid>
    )
}

export default DealEmail;